var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3485 5.40869C15.4618 5.40869 5.01514 15.8554 5.01514 28.742C5.01514 41.6287 15.4618 52.0754 28.3485 52.0754C41.2351 52.0754 51.6818 41.6287 51.6818 28.742C51.6818 15.8554 41.2351 5.40869 28.3485 5.40869ZM28.3485 5.40869C32.1546 5.40869 35.9031 6.3398 39.2668 8.12083C42.6306 9.90185 45.5076 12.4787 47.647 15.6267C49.7864 18.7747 51.1232 22.3984 51.5409 26.1815C51.9585 29.9648 51.4444 33.7926 50.0432 37.3316C48.6421 40.8705 46.3965 44.0129 43.5023 46.4848C40.608 48.9567 37.153 50.6832 33.4385 51.5134C29.724 52.3437 25.8628 52.2527 22.1914 51.2483C18.5201 50.244 15.1503 48.3568 12.3758 45.7513L28.3485 28.742V5.40869Z",
    stroke: "#2D2943",
    strokeWidth: 2.62944,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieFive);
export default __webpack_public_path__ + "static/media/pie-five.a1d797c0.svg";
export { ForwardRef as ReactComponent };